export default "__VITE_ASSET__CH90m38V__"